var map = {
	"./de_DE.json": "./src/api/i18n/de_DE.json",
	"./en_US.json": "./src/api/i18n/en_US.json",
	"./es_ES.json": "./src/api/i18n/es_ES.json",
	"./fr_FR.json": "./src/api/i18n/fr_FR.json",
	"./it_IT.json": "./src/api/i18n/it_IT.json",
	"./ja_JP.json": "./src/api/i18n/ja_JP.json",
	"./ko_KO.json": "./src/api/i18n/ko_KO.json",
	"./pt_PT.json": "./src/api/i18n/pt_PT.json",
	"./tr_TR.json": "./src/api/i18n/tr_TR.json",
	"./vi_VI.json": "./src/api/i18n/vi_VI.json",
	"./zh_CN.json": "./src/api/i18n/zh_CN.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api/i18n sync recursive ^\\.\\/.*\\.json$";